import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';
import { useLabels } from 'wsm-common-data';
import { isBrowser } from 'ws-scripts/modules/environment';

const Error = (props) => {
	let isComposer = false;
	const labels = useLabels();

	if (isBrowser) {
		isComposer = !!window.top?.composer;
	}

	return !props.price && isComposer ? (
		<Alert bsStyle="warning">
			<i className="ddc-icon ddc-icon-alert" aria-hidden="true" />
			<div className="alert-content">
				{labels.get('NO_PRICE_FIELD_WARNING_MESSAGE')}
			</div>
		</Alert>
	) : (
		<span />
	);
};

Error.propTypes = {
	price: PropTypes.number.isRequired
};

export default Error;
